export const getRightDaysDeclension = (num: number): string => {
  const stringNum = num.toString();
  const lastDigit = Number(stringNum[stringNum.length - 1]);

  if (lastDigit === 0 || lastDigit > 4) {
    return 'дней';
  } else if (lastDigit === 1) {
    return 'день';
  }
  return 'дня';
};
